/**
 * Estado visual de un evento de agenda para el modo móvil del perito.
 *
 *   pending   → AZUL  (visita programada, sin iniciar y aún no ha pasado la hora)
 *   visited   → VERDE (visita iniciada o terminada por el perito)
 *   delayed   → ROJO  (visita programada, sin iniciar y la hora ya pasó)
 *   cancelled → GRIS  (visita cancelada)
 */
export function computeEventState(ev, now = new Date()) {
  if (ev?.status === "cancelled") return "cancelled";
  if (ev?.visit_started_at || ev?.status === "done") return "visited";
  const starts = ev?.starts_at ? new Date(ev.starts_at) : null;
  if (starts && starts.getTime() < now.getTime()) return "delayed";
  return "pending";
}

export const STATE_STYLES = {
  pending: {
    label: "Pendiente",
    badge: "bg-blue-100 text-blue-800 border-blue-200",
    bar: "bg-blue-500",
    dot: "bg-blue-500",
    ring: "ring-blue-200",
    card: "border-l-4 border-l-blue-500 bg-white",
  },
  visited: {
    label: "Visitado",
    badge: "bg-emerald-100 text-emerald-800 border-emerald-200",
    bar: "bg-emerald-500",
    dot: "bg-emerald-500",
    ring: "ring-emerald-200",
    card: "border-l-4 border-l-emerald-500 bg-emerald-50/40",
  },
  delayed: {
    label: "Retrasado",
    badge: "bg-red-100 text-red-800 border-red-200",
    bar: "bg-red-500",
    dot: "bg-red-500",
    ring: "ring-red-200",
    card: "border-l-4 border-l-red-500 bg-red-50/40",
  },
  cancelled: {
    label: "Cancelado",
    badge: "bg-zinc-100 text-zinc-600 border-zinc-200",
    bar: "bg-zinc-400",
    dot: "bg-zinc-400",
    ring: "ring-zinc-200",
    card: "border-l-4 border-l-zinc-400 bg-white opacity-60",
  },
};

export const isMobileUA = () =>
  typeof navigator !== "undefined" &&
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent || "");
